import {
    dangerouslyLoadTrustedFormScript,
    getTrustedFormFieldValues,
} from '@clearlink/emily';

const loadTrustedFormScript = (formSelector = '') => {
    // only load if Move Marketplace is NOT on page
    if (!document.querySelector('.mm__form')) {
        dangerouslyLoadTrustedFormScript(formSelector);
    }
};

const leadForm = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const forms = document.querySelectorAll('.lead-form__form');

        loadTrustedFormScript('.lead-form__form');

        if (forms.length === 0) {
            return;
        }

        forms.forEach(async (form) => {
            let isSubmitting = false;
            const successMessageElement =
                form.querySelector('.success-message');
            const headingElement = form.querySelector('.lead-form--heading');
            const formFieldContainerElement = form.querySelector('.lead-form__field-container');
            const errorMessageElement = form.querySelector('.error-message');
            const aqsMessage = form.querySelector('#aqs_message');
            const language = form.querySelector('input[name="language"]').value;
            const formAction = form.dataset.action;

            // Checkboxes for general form
            const selectAllCheckbox = form.querySelector(
                'input[name="consent_select_all"]'
            );
            const consentCheckboxes = form.querySelectorAll(
                'input[name="brand_consent"]'
            );

            // Checkbox Select All Functionality
            if (selectAllCheckbox && consentCheckboxes.length > 0) {
                selectAllCheckbox.addEventListener('change', (event) => {
                    consentCheckboxes.forEach((checkbox) => {
                        if (!checkbox.disabled) {
                            checkbox.checked = event.target.checked;
                        }
                    });
                });
            }

            window.clwpForm.addAction(
                formAction,
                () =>
                    new Promise(async (resolve, reject) => {
                        try {
                            // Avoid duplicate submissions
                            if (isSubmitting) {
                                return; // Exit the submit early, this is a duplicate submission
                            }

                            isSubmitting = true;

                            // reset message output areas
                            headingElement.style.display = 'block';
                            successMessageElement.style.display = 'none';
                            errorMessageElement.style.display = 'none';
                            aqsMessage.style.display = 'none';

                            let mapiData = localStorage.getItem('mapi');
                            const MM_ZIP = localStorage.getItem('MM_ZIP');
                            const USER_IP = localStorage.getItem('USER_IP');
                            let requestId = '';
                            let promoCode = '';

                            if (mapiData) {
                                mapiData = JSON.parse(mapiData);
                                requestId = mapiData.requestId;
                                promoCode = mapiData.lastPromo;
                            }

                            const formData = new FormData(form);
                            const tcpaApiLink = formData.get('tcpa_api_link');
                            const emilyApiLink = formData.get('emily_api_link');
                            const trustedFormFields =
                                await getTrustedFormFieldValues(form);
                            const selectAllBool =
                                formData.get('consent_select_all') === 'true';
                            const consentCheckboxFieldset = form.querySelector(
                                '.lead-form__fieldset--checkbox-consent'
                            );
                            const consentCheckboxFieldsetMessage =
                                consentCheckboxFieldset?.querySelector(
                                    '.form-input__description-above'
                                );

                            let mover_ref = formData.get('mover_ref');

                            // If the mover_ref is general, we need to check if any brands were selected
                            if (mover_ref === 'general') {
                                const consentedBrands =
                                    formData.getAll('brand_consent');

                                // Don't submit if no brands were selected, show error message, scroll to fieldset
                                if (consentedBrands.length === 0) {
                                    if (consentCheckboxFieldsetMessage) {
                                        consentCheckboxFieldsetMessage.classList.add(
                                            'has-error'
                                        );
                                    }

                                    consentCheckboxFieldset.scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'start',
                                    });

                                    return; // Exit the submit early
                                }

                                // Set mover_ref to the selected brands as an array of strings (Emily API expects this)
                                if (consentedBrands.length > 0) {
                                    mover_ref = consentedBrands;
                                }
                            }

                            const dataForTCPA = {
                                phones: formData.get('phone_number'),
                                email: formData.get('email'),
                                brand: formData.get('brand'),
                                consent_type: formData.get('consent_type'),
                                request_id: requestId,
                                xxTrustedFormCertUrl:
                                    trustedFormFields.xxTrustedFormCertUrl ||
                                    'failed_to_get_trusted_form_cert_url',
                            };

                            if (tcpaApiLink) {
                                const tcpaResponse = await fetch(tcpaApiLink, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify(dataForTCPA),
                                });

                                if (!tcpaResponse.ok) {
                                    throw new Error(
                                        `TCPA Network response was not ok. Status: ${tcpaResponse.status}, Text: ${tcpaResponse.statusText}`
                                    );
                                }

                                const dataForEmily = {
                                    // moving from fields:
                                    address1: formData.get('address1'),
                                    address2: formData.get('address2'),
                                    city1: formData.get('city1'),
                                    state1: formData.get('state1'),
                                    zip1: formData.get('zip1'),

                                    // moving to fields
                                    city2: formData.get('city2'),
                                    state2: formData.get('state2'),
                                    zip2: formData.get('zip2'),
                                    moving_size: formData.get('moving_size'),
                                    moving_date: formData.get('moving_date'),

                                    // contact info fields
                                    first_name: formData.get('first_name'),
                                    last_name: formData.get('last_name'),
                                    email: formData.get('email'),
                                    phone_number: formData.get('phone_number'),

                                    // keep old zip fields (for testing purposes)
                                    moving_to: formData.get('zip2'),
                                    moving_from: formData.get('zip1'),

                                    brand: formData.get('brand'),
                                    source: formData.get('source'),
                                    domain: formData.get('domain'),
                                    elqFormName: formData.get('elqFormName'),
                                    partner_name: mover_ref,
                                    tune_transaction_id: formData.get('transaction_id'),
                                    xxTrustedFormCertUrl: formData.get('xxTrustedFormCertUrl'),
                                    xxTrustedFormToken: formData.get('xxTrustedFormToken'),
                                    select_all: selectAllBool,
                                    request_id: requestId,
                                    promo_code: promoCode,
                                    language,
                                    user_zip: MM_ZIP,
                                    user_ip: USER_IP,
                                };

                                if (emilyApiLink) {
                                    const emilyResponse = await fetch(
                                        emilyApiLink,
                                        {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type':
                                                    'application/json',
                                            },
                                            body: JSON.stringify(dataForEmily),
                                        }
                                    );

                                    if (emilyResponse.status === 200) {
                                        // reset input values and validation markers
                                        const validatedFields =
                                            form.querySelectorAll(
                                                '.form-input__field.is-valid'
                                            );
                                        validatedFields.forEach((field) => {
                                            const inputs =
                                                field.querySelectorAll(
                                                    '.form-field'
                                                );
                                            inputs.forEach(
                                                (input) => (input.value = '')
                                            );
                                            field.classList.remove('is-valid');
                                        });

                                        // Reset select all checkbox
                                        if (selectAllCheckbox) {
                                            selectAllCheckbox.checked = false;
                                        }

                                        // Reset checkboxes
                                        if (consentCheckboxes.length > 0) {
                                            consentCheckboxes.forEach(
                                                (checkbox) => {
                                                    checkbox.checked = false;
                                                }
                                            );
                                        }

                                        // reset address validation message
                                        aqsMessage.style.display = 'none';

                                        // remove any checkbox field error messages
                                        if (consentCheckboxFieldsetMessage) {
                                            consentCheckboxFieldsetMessage.classList.remove(
                                                'has-error'
                                            );
                                        }

                                        // Scroll to the top of form, where the success message is displayed
                                        form.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                        });

                                        // hide main heading
                                        headingElement.style.display = 'none';

                                        // hide all form fields, etc.
                                        formFieldContainerElement.style.display = 'none';

                                        // show success message
                                        successMessageElement.style.display = 'block';
                                        if (language === 'es') {
                                            successMessageElement.innerHTML = "<div class=\"success-icon sc-margin--lg\"></div><h3 class=\"clwp-heading clwp-heading--h3\">Los transportistas se pondrán en contacto contigo en breve para ofrecerte un presupuesto.</h3><p>¡Te deseamos un feliz traslado!</p>";
                                        } else {
                                            successMessageElement.innerHTML = "<div class=\"success-icon sc-margin--lg\"></div><h3 class=\"clwp-heading clwp-heading--h3\">The movers will contact you soon to provide a quote.</h3><p>Best wishes for a successful move!</p>";
                                        }
                                    } else if (language === 'es') {
                                        // Scroll to the top of form, where the error message is displayed
                                        form.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                        });

                                        errorMessageElement.style.display = 'block';
                                        errorMessageElement.innerHTML = `<h3 class="clwp-heading clwp-heading--h3 lead-form--message-red">¡Lo sentimos! Algo salió mal. Por favor, inténtalo nuevamente.</h3>`;
                                    } else {
                                        // Scroll to the top of form, where the error message is displayed
                                        form.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                        });

                                        errorMessageElement.style.display = 'block';
                                        errorMessageElement.innerHTML = `<h3 class="clwp-heading clwp-heading--h3 lead-form--message-red">Sorry something went wrong! Please try again.</h3>`;
                                    }
                                }
                            }
                        } catch (error) {
                            // Scroll to the top of form, where the error message is displayed
                            form.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                            });

                            if (language === 'es') {
                                errorMessageElement.innerHTML = `<h3 class="clwp-heading clwp-heading--h3">¡Lo sentimos! Algo salió mal. Por favor, inténtalo nuevamente.</h3>`;
                            } else {
                                errorMessageElement.innerHTML = `<h3 class="clwp-heading clwp-heading--h3">Sorry, something went wrong! Please try again.</h3>`;
                            }
                            reject({
                                error,
                                success: false,
                                data: {
                                    message:
                                        'There was a problem in submitting your data.',
                                    buttonMessage:
                                        'Try Again! <img src="/app/themes/coolwhip/assets/icons/forms/error.svg" class="clwp-icon clwp-icon--sm" alt="filled red circle with the letter i cut out of the middle">',
                                },
                                customTimeout: 6000,
                            });
                        } finally {
                            // Reset the isSubmitting flag
                            isSubmitting = false;

                            resolve({
                                success: true,
                                data: {
                                    message: '', // This will show up under the button on the form, our message is in the heading, so this is blank
                                },
                                customTimeout: 6000,
                            });

                            console.log('Form submission process completed');
                        }
                    })
            );
        });
    });
};

export default leadForm;

export const addressQual = () => {
    document.addEventListener('DOMContentLoaded', () => {
        // monitor changes in address fields
        const monitorAddressFields = (form) => {
            const aqsMessage = form.querySelector('#aqs_message');
            const language = form.querySelector('input[name="language"]').value;
            const addressFieldNames = ['address1', 'address2', 'state1', 'city1', 'zip1'];
            const fieldElements = {};

            // get field elements by their names within target form ID
            addressFieldNames.forEach(name => {
                const elements = document.getElementsByName(name);

                for (const elem of elements) {
                    if (elem.closest('.lead-form__form')?.id === form.id) {
                        fieldElements[name] = elem;
                    }
                }
            });

            // helper function to fetch the normalized address
            const fetchNormalizedAddress = async (rawAddress, inputZip) => {
                try {
                    const response = await fetch(`https://aqs.clear.link/addresses/normalize?raw_address=${encodeURIComponent(rawAddress)}`, {
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' },
                    });

                    if (response.ok) {
                        const data = await response.json();
                        if (data.addresses && Array.isArray(data.addresses)) {
                            if (data.addresses[0].postal_code === inputZip) {
                                aqsMessage.style.display = 'block';
                                if (language === 'es') {
                                    aqsMessage.innerHTML = "Dirección verificada.";
                                } else {
                                    aqsMessage.innerHTML = "Address verified.";
                                }
                            } else {
                                aqsMessage.style.display = 'none';
                            }
                        } else {
                            aqsMessage.style.display = 'none';
                        }
                    } else {
                        console.error('API request failed:', response.errors);
                        aqsMessage.style.display = 'none';
                    }
                } catch (error) {
                    console.error('API request failed:', error);
                }
            };

            // Combine address fields and query API when all fields are filled
            const handleFieldChange = () => {

                const addressFields = {
                    address1: fieldElements.address1.value.trim(),
                    address2: fieldElements.address2.value.trim(),
                    city1: fieldElements.city1.value.trim(),
                    state1: fieldElements.state1.value.trim(),
                    zip1: fieldElements.zip1.value.trim(),
                };

                // required address fields (excluding address2)
                const requiredFields = ['address1', 'city1', 'state1', 'zip1'];

                const allRequiredFieldsFilled = requiredFields.every(field => addressFields[field] !== '');

                if (!allRequiredFieldsFilled) {
                    aqsMessage.style.display = 'none';
                    return null;
                }

                // construct rawAddress, including address2 if it has a value
                const rawAddressParts = [
                    addressFields.address1,
                    addressFields.address2, // optional: include even if empty
                    addressFields.city1,
                    addressFields.state1,
                    addressFields.zip1,
                ].filter(part => part !== ''); // remove empty values (like empty address2)

                const rawAddress = rawAddressParts.join(' ');

                if (rawAddress) {
                    fetchNormalizedAddress(rawAddress, addressFields.zip1);
                }
            };

            // add event listeners to each field
            Object.values(fieldElements).forEach(elem => {
                if (elem) elem.addEventListener('focusout', handleFieldChange);
            });
        };

        const monitorFieldsForLocalMoves = (form) => {
            const moverRef = form.querySelector('input[name="mover_ref"]');
            const submitButton = form.querySelector('.submit-button');
            const warningLocalMove1 = form.querySelector('.warning-local-move1');
            const warningLocalMove2 = form.querySelector('.warning-local-move2');
            let mayzlinSingleUse = false;

            // check mover_ref value for "Mayzlin Relocation" provider names if value
            // set to a single moving provider (single-provider form; not bulk)
            if (typeof moverRef.value === "string") {
                if (moverRef.value === "Mayzlin Relocation") {
                    mayzlinSingleUse = true;
                }
            }

            const state1 = form.querySelector('select[name="state1"]');
            const state2 = form.querySelector('select[name="state2"]');
            const zip1 = form.querySelector('input[name="zip1"]');
            const zip2 = form.querySelector('input[name="zip2"]');

            const showWarningLocalMove = () => {
                warningLocalMove1.style.display = 'block';
                warningLocalMove2.style.display = 'block';
                submitButton.disabled = true;
            }

            const hideWarningLocalMove = () => {
                warningLocalMove1.style.display = 'none';
                warningLocalMove2.style.display = 'none';
                submitButton.disabled = false;
            }

            const disableMoverCheckboxes = () => {
                const moverCheckboxes = form.querySelectorAll('input[type="checkbox"]');
                moverCheckboxes.forEach(checkbox => {
                    checkbox.disabled = true;
                });
                const moverLabels = form.querySelectorAll('label.form-field--checkbox');
                moverLabels.forEach(label => {
                    label.classList.add('form-field--checkbox-disabled');
                });
            }

            const enableMoverCheckboxes = () => {
                const moverCheckboxes = form.querySelectorAll('input[type="checkbox"]');
                moverCheckboxes.forEach(checkbox => {
                    checkbox.disabled = false;
                });
                const moverLabels = form.querySelectorAll('label.form-field--checkbox');
                moverLabels.forEach(label => {
                    label.classList.remove('form-field--checkbox-disabled');
                });
            }

            const checkFieldValues = () => {
                const state1Value = state1.value;
                const state2Value = state2.value;
                const zip1Value = zip1.value.trim();
                const zip2Value = zip2.value.trim();

                if ((state1Value && state2Value) || (zip1Value && zip2Value)) {
                    // check if states or zip codes are the same
                    if (((state1Value && state2Value) && state1Value === state2Value) || ((zip1Value && zip2Value) && zip1Value === zip2Value)) {
                        // show warning messages in the appropriate places
                        if (!mayzlinSingleUse) { // do NOT show warning if form is dedicated to Mayzlin Relocation (as they DO support local moves)
                            showWarningLocalMove();
                            disableMoverCheckboxes();
                        }
                    } else {
                        hideWarningLocalMove();
                        enableMoverCheckboxes();
                    }
                } else {
                    hideWarningLocalMove();
                    enableMoverCheckboxes();
                }
            };

            const debounceEvent = (func, delay) => {
                let timer;
                return function (...args) {
                    clearTimeout(timer);
                    timer = setTimeout(() => func.apply(this, args), delay);
                };
            };

            // add event listeners to detect perceived "local moves"
            [state1, state2, zip1, zip2].forEach(input => {
                input.addEventListener('input', debounceEvent(checkFieldValues, 1000));
            });
        };

        const monitorMovingDate = (form) => {
            const movingDateField = form.querySelector('input[name="moving_date"]');

            const slowProviders = ['United Van Lines', 'Mayflower', 'Safeway Moving'];
            const toggleDisableSlowProviders = (toggle) => {
                const providerCheckboxes = form.querySelectorAll('input[type="checkbox"]');
                providerCheckboxes.forEach((checkbox) => {
                    if (slowProviders.includes(checkbox.value)) {
                        checkbox.disabled = toggle;

                        if (toggle) {
                            checkbox.checked = !toggle; // uncheck if checked
                        }

                        if (checkbox.parentElement.tagName.toLowerCase() === 'label') {
                            const label = checkbox.parentElement;

                            if (toggle) {
                                label.classList.add('form-field--checkbox-disabled');
                            } else {
                                label.classList.remove('form-field--checkbox-disabled');
                            }
                        }
                    }
                });
            }

            movingDateField.addEventListener('change', (e) => {
                const today = new Date();
                const tenDaysFromNow = new Date();
                tenDaysFromNow.setDate(today.getDate() + 10);

                const movingDateValue = new Date(e.target.value);
                movingDateValue.setDate(movingDateValue.getDate() + 1);

                // normalize all dates to the start of the day
                today.setHours(0, 0, 0, 0);
                tenDaysFromNow.setHours(0, 0, 0, 0);
                movingDateValue.setHours(0, 0, 0, 0);

                // disable/enable moving options for: united van lines, mayflower, and safeway
                if (movingDateValue >= today && movingDateValue <= tenDaysFromNow) {
                    toggleDisableSlowProviders(true);
                } else {
                    toggleDisableSlowProviders(false);
                }
            });
        };

        // distinguish between each form on the page and set up monitoring
        const forms = document.querySelectorAll('.lead-form__form');
        forms.forEach(form => {
            if (form.id) {
                monitorAddressFields(form);
                monitorFieldsForLocalMoves(form);
                monitorMovingDate(form);
            }
        });
    });
}
